<template>
    <div class="user-menu-container" @click.stop="toggleMenu">
        <img class="user-icon" :src="userIcon" alt="User" />

        <!-- Dropdown (desktop + mobile chung) -->
        <transition name="fade-slide">
            <div v-if="showMenu" :class="['user-dropdown', { mobile: isMobile }]">
                <RouterLink to="/dispath" class="dropdown-item">Trang quản lý</RouterLink>
                <RouterLink to="/" class="dropdown-item">Trang người dùng</RouterLink>
                <RouterLink to="/profile-staff" class="dropdown-item">Thông tin cá nhân</RouterLink>
                <RouterLink to="/change-password" class="dropdown-item">Đổi mật khẩu</RouterLink>
                <RouterLink to="#" class="dropdown-item" @click.prevent="logout">Đăng xuất</RouterLink>
            </div>
        </transition>
    </div>
</template>

<script setup>
    import { ref, onMounted, onUnmounted } from "vue";
    import userIcon from "@/assets/images/ic-mascot.png";
    import { AuthService } from "@/services/AuthService";

    const showMenu = ref(false);
    const isMobile = ref(window.innerWidth <= 768);

    function toggleMenu() {
        showMenu.value = !showMenu.value;
    }

    function handleResize() {
        isMobile.value = window.innerWidth <= 768;
    }

    function closeMenu(e) {
        if (!e.target.closest(".user-menu-container")) showMenu.value = false;
    }

    async function logout() {
        await AuthService.logout();
        window.location.href = "/login";
    }

    onMounted(() => {
        document.addEventListener("click", closeMenu);
        window.addEventListener("resize", handleResize);
    });
    onUnmounted(() => {
        document.removeEventListener("click", closeMenu);
        window.removeEventListener("resize", handleResize);
    });
</script>

<style scoped>
    .user-menu-container {
        position: relative;
        cursor: pointer;
    }

    .user-icon {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        object-fit: cover;
    }

    /* Dropdown chung */
    .user-dropdown {
        position: absolute;
        top: 100%;
        right: 0;
        min-width: 180px;
        background: white;
        color: black;
        border-radius: 4px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        display: flex;
        flex-direction: column;
        padding: 0.5rem 0;
        z-index: 9999;
    }

    /* Mobile style */
    .user-dropdown.mobile {
        top: 110%;
        padding: 0.5rem 1rem;
    }

    /* Dropdown items */
    .dropdown-item {
        padding: 0.5rem 1rem;
        text-decoration: none;
        color: inherit;
    }

    .dropdown-item:hover {
        background-color: #f0f0f0;
    }

    /* Animation */
    .fade-slide-enter-active,
    .fade-slide-leave-active {
        transition: all 0.2s ease;
    }

    .fade-slide-enter-from,
    .fade-slide-leave-to {
        opacity: 0;
        transform: translateY(-10px);
    }
</style>